import { render, staticRenderFns } from "./StartGenerator.vue?vue&type=template&id=2b8c8a76&scoped=true&"
import script from "./StartGenerator.vue?vue&type=script&lang=js&"
export * from "./StartGenerator.vue?vue&type=script&lang=js&"
import style0 from "./StartGenerator.vue?vue&type=style&index=0&id=2b8c8a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c8a76",
  null
  
)

export default component.exports